export default base64 => {
    const binString = atob(base64)
    return Uint8Array.from(binString, m => m.codePointAt(0))
}
